import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import type { FormItemProps, SelectProps } from 'antd';
import i18n from 'i18next';

import { routeFileSelector } from '../../../../../utilz/i18n';
import FormSelectBox from '../../../../components/Inputs/FormSelectBox';
import { useGetShipmentTerms } from '../../hooks';

interface ShipmentTermsSelect extends Pick<FormItemProps, 'rules' | 'name'>, Pick<SelectProps, 'placeholder'> {
  label?: string;
  editMode?: boolean;
  margin?: string;
  tooltip?: boolean;
  isDefault?: boolean;
  disableValidation?: boolean;
  onChange?: (value: unknown) => void;
  disableDefaultOptions?: boolean;
  isRequired?: boolean;
}

export const ShipmentTermsSelect: FC<ShipmentTermsSelect> = ({
  placeholder = i18n.t('translation:default.fields.shipmentTerms.placeholder'),
  label = i18n.t('translation:default.fields.shipmentTerms.label'),
  rules = [],
  name,
  editMode,
  margin,
  tooltip = false,
  isDefault = false,
  disableValidation = false,
  onChange,
  disableDefaultOptions = false,
  isRequired = false,
}) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const { data: options = [], isLoading } = useGetShipmentTerms();

  return (
    <FormSelectBox
      loading={isLoading}
      options={
        !disableDefaultOptions
          ? isDefault
            ? [{ label: t('translation:default.buttons.select'), value: '' }, ...options]
            : [
                {
                  label: `--${t('translation:default.options.all')}--`,
                  value: '',
                },
                ...options,
              ]
          : options
      }
      placeholder={placeholder}
      label={label}
      isRequired={isRequired}
      rules={rules}
      name={name}
      editMode={editMode}
      margin={margin}
      tooltip={tooltip}
      disableValidation={disableValidation}
      onChange={onChange}
    />
  );
};
